module.exports = function addKeyPressEventListener(element, keyCode, handler) {
  element.addEventListener('keydown', function (e) {
    if (e.keyCode !== keyCode) { return; }
    handler(e);
  });
};



//////////////////
// WEBPACK FOOTER
// ./src/js/helpers/addkeypresseventlistener.js
// module id = 29
// module chunks = 0